import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  Button,
  FormControl,
  Input,
  FormLabel,
} from "@chakra-ui/react";
import React, { useState } from "react";

export default function DateRangeModal({
  isOpen,
  onClose,
  startDate,
  endDate,
  setStartDate,
  setEndDate,
  func,
}: any) {

  const initialRef = React.useRef(null);
  
  return (
    <>
      <Modal initialFocusRef={initialRef} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader>Custom Date Range</ModalHeader>
          <ModalCloseButton />
          <ModalBody pb={6}>
            <FormControl>
              <FormLabel>Start Date</FormLabel>
              <Input
                value={startDate}
                type="date"
                ref={initialRef}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </FormControl>

            <FormControl mt={4}>
              <FormLabel>End Date</FormLabel>
              <Input
                value={endDate}
                type="date"
                ref={initialRef}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </FormControl>
          </ModalBody>

          <ModalFooter>
            <Button
              bgColor="#327171"
              color={"white"}
              mr={3}
              onClick={() => {
                func(startDate, endDate);
                onClose();
              }}
            >
              Submit
            </Button>
            <Button bgColor="red" color={"white"} onClick={onClose}>
              Cancel
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
